import { useMemo } from 'react';

import {
  getStakeMessage,
  SupportedLocale,
  StakeMessageKey,
  StakeMessageContext,
} from '../i18n/stakeMessages';

export interface UseStakeErrorMessageOptions {
  errorKey: string | null;
  locale?: SupportedLocale;
  /**
   * Chain-specific interpolation context for the error message.
   * Falls back to POL defaults when omitted.
   */
  context?: StakeMessageContext;
}

/**
 * Hook for getting translated stake validation error messages.
 */
export const useStakeErrorMessage = ({
  errorKey,
  locale,
  context,
}: UseStakeErrorMessageOptions): string | null => {
  return useMemo(
    () => getStakeMessage(errorKey as StakeMessageKey | null, locale, context),
    [errorKey, locale, context],
  );
};
